import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createSlots as _createSlots, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/guanbi.png'


const _withScopeId = n => (_pushScopeId("data-v-3dd2e005"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "topDownloadBox"
}
const _hoisted_2 = { class: "topDownload-keep-px" }
const _hoisted_3 = { class: "leftcon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "rightcon" }
const _hoisted_6 = {
  key: 1,
  class: "topSearchBox-keep-px"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "oppen-rl" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "AdBox" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100vw","height":"100vh"} }
const _hoisted_17 = {
  class: "header",
  style: {"min-height":"32px"}
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "con" }
const _hoisted_20 = ["src"]
const _hoisted_21 = ["href"]
const _hoisted_22 = ["src"]
const _hoisted_23 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($setup.appChannel == 'yn')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createCommentVNode(" 顶部的下载app视图 "),
          ($setup.showDownApp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("img", { src: $setup.home_lefttop_white_gif }, null, 8 /* PROPS */, _hoisted_4)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    ($setup.showDownApp == 2)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "btn",
                          style: _normalizeStyle({ backgroundColor: $setup.activeColor, color: $setup.activeFontColor }),
                          onClick: $setup.toDownWebclip
                        }, _toDisplayString(_ctx.$t('tips.addHomeScreen')), 5 /* TEXT, STYLE */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", {
                      class: "btn",
                      style: _normalizeStyle({ backgroundColor: $setup.activeColor, color: $setup.activeFontColor }),
                      onClick: $setup.toDownApp
                    }, _toDisplayString(_ctx.$t('home.downapp')), 5 /* TEXT, STYLE */)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("img", {
                  class: "logo",
                  src: $setup.home_lefttop_white_gif
                }, null, 8 /* PROPS */, _hoisted_7),
                _createElementVNode("div", {
                  class: "inputBox",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.push('/search')))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('home.searchplace')), 1 /* TEXT */),
                  _createElementVNode("img", { src: $setup.searchIcon }, null, 8 /* PROPS */, _hoisted_8)
                ])
              ])),
          _createCommentVNode(" 分类栏 "),
          ($setup.showHomeTabs)
            ? (_openBlock(), _createBlock(_component_van_tabs, {
                key: 2,
                active: $setup.active,
                "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => (($setup.active) = $event)),
                style: _normalizeStyle({ top: $setup.showDownApp ? '60px' : '60px' }),
                "offset-top": $setup.showDownApp ? '60px' : 60,
                color: $setup.tabBgColor,
                "title-active-color": $setup.titleActiveColor,
                ellipsis: false,
                "title-inactive-color": $setup.titleInactiveColor,
                background: $setup.tabBgColor,
                sticky: "",
                onChange: $setup.tabsChange
              }, _createSlots({
                default: _withCtx(() => [
                  _createVNode(_component_van_tab, {
                    title: $setup.t('home.Tab_0')
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["HomeIndex"], { onHometab: $setup.hometab })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["title"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.homeTabs, (tab) => {
                    return (_openBlock(), _createBlock(_component_van_tab, {
                      key: tab.type,
                      title: tab.name
                    }, {
                      title: _withCtx(() => [
                        (tab.type == $setup.WORLD_CUP_TAB_TYPE && tab.icon_black)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "world-cup-tab-icon",
                              src: tab.icon_black,
                              alt: tab.name
                            }, null, 8 /* PROPS */, _hoisted_11))
                          : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(tab.name), 1 /* TEXT */))
                      ]),
                      default: _withCtx(() => [
                        (tab.type == $setup.WORLD_CUP_TAB_TYPE)
                          ? (_openBlock(), _createBlock($setup["HomeWorldCup"], { key: 0 }))
                          : (tab.type == 7)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createCommentVNode(" 7是新闻资讯 "),
                                _createVNode($setup["Newsletter"])
                              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                            : (_openBlock(), _createBlock($setup["HomeFootball"], {
                                key: 2,
                                type: tab.type
                              }, null, 8 /* PROPS */, ["type"]))
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createVNode(_component_van_tab, {
                    title: $setup.t('home.Tab_6')
                  }, {
                    default: _withCtx(() => [
                      _createVNode($setup["HomeFootball"], { type: 99 })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["title"])
                ]),
                _: 2 /* DYNAMIC */
              }, [
                ($setup.showDownApp)
                  ? {
                      name: "nav-right",
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("img", {
                            src: $setup.searchIcon,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push('/search')))
                          }, null, 8 /* PROPS */, _hoisted_10)
                        ])
                      ])
                    }
                  : undefined
              ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["active", "style", "offset-top", "color", "title-active-color", "title-inactive-color", "background"]))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createBlock($setup["HomeIndexVi"], {
          key: 1,
          homeTabs: $setup.homeTabs
        }, null, 8 /* PROPS */, ["homeTabs"])),
    _createCommentVNode(" 已废弃 "),
    _createVNode(_component_van_overlay, {
      show: $setup.alertAd,
      "z-index": "99999",
      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => ($setup.offActivity()), ["stop"]))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", {
            class: "conterBox",
            style: _normalizeStyle({ backgroundImage: 'url(' + $setup.homexbod + ')' })
          }, [
            _createElementVNode("img", {
              src: $setup.alertRedImg,
              class: "linearBox"
            }, null, 8 /* PROPS */, _hoisted_14),
            _createElementVNode("img", {
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.toActivity()), ["stop"])),
              src: $setup.homexadBtn,
              class: "btn"
            }, null, 8 /* PROPS */, _hoisted_15)
          ], 4 /* STYLE */),
          _createElementVNode("img", {
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.offActivity()), ["stop"])),
            class: "close",
            src: _imports_0,
            alt: ""
          })
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"]),
    _createVNode(_component_van_overlay, {
      show: $setup.showUrlList,
      "z-index": "99999"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "urlListDialog",
            onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("img", { src: $setup.home_lefttop_black_gif }, null, 8 /* PROPS */, _hoisted_18),
              _createCommentVNode(" <span class=\"url\" v-if=\"forever_url && forever_url.length > 0\">{{ forever_url[0] }}</span> "),
              _createCommentVNode(" <span>·看尽天下赛事</span> ")
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", null, [
                _createElementVNode("img", { src: $setup.url_list_con_title }, null, 8 /* PROPS */, _hoisted_20),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.forever_url, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item,
                    class: "item"
                  }, [
                    _createElementVNode("a", {
                      href: item.indexOf('http') == -1 ? 'http://' + item : item,
                      target: "_blank"
                    }, _toDisplayString(item), 9 /* TEXT, PROPS */, _hoisted_21)
                  ]))
                }), 128 /* KEYED_FRAGMENT */)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('tips.ptaddress') + " " + $setup.appname), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("img", {
              class: "okBtn",
              src: $setup.url_list_ok,
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.showUrlList = false)),
              alt: ""
            }, null, 8 /* PROPS */, _hoisted_22),
            _createElementVNode("img", {
              class: "offbtn",
              src: $setup.url_list_close,
              alt: "",
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.showUrlList = false))
            }, null, 8 /* PROPS */, _hoisted_23)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"])
  ]))
}